module.exports = __webpack_public_path__ + "static/media/Vault Add-in Enhancements.e6de0a3e.png";